export default function removeQueryParam(params: Array<string>) {
  const url = new URL(window.location.href);

  const hasAnyParam = params.some(param => url.searchParams.has(param));
  if (!hasAnyParam) return;

  params.forEach(param => url.searchParams.delete(param));
  window.history.replaceState({}, '', url.pathname + url.search);
}
